const HttpBackend = require("i18next-http-backend/cjs")
const ChainedBackend = require("i18next-chained-backend").default
const LocalStorageBackend = require("i18next-localstorage-backend").default

// Locales built for this site. US builds ship "en" only; Canada ships "en,fr".
// Falls back to both so local dev and unconfigured pipelines keep working.
const supportedLocales = (process.env.NEXT_PUBLIC_SUPPORTED_LOCALES || "en,fr")
  .split(",")
  .map(locale => locale.trim())
  .filter(Boolean)

module.exports = {
  backend: {
    backendOptions: [
      { expirationTime: 60 * 60 * 1000 },
      {
        // need to revisit this block to load dictionaryPath from global config -  currently not possible due to incompatability with cjs modules. need to redefine imports and exports in future
        loadPath: async function (lng, ns) {
          const dictionaryPath = "/content/kohler.i18nDictionary.json"
          return `/api/locales/${lng}/${ns}.json?path=${dictionaryPath}`
        },
      },
    ],
    backends:
      typeof window !== "undefined" ? [LocalStorageBackend, HttpBackend] : [],
  },
  i18n: {
    locales: ["default", ...supportedLocales],
    defaultLocale: "default",
    localeDetection: false,
  },
  ns: ["common"],
  serializeConfig: false,
  use: typeof window !== "undefined" ? [ChainedBackend] : [],
}
